import React, { useState } from "react";
import { Container, Form, Row, Col, Button, Alert } from "react-bootstrap";

const LPGCalculator = () => {
    const [distance, setDistance] = useState("");
    const [fuelEfficiency, setFuelEfficiency] = useState("");
    const [lpgEfficiency, setLpgEfficiency] = useState("");
    const [fuelPrice, setFuelPrice] = useState(175); // Default per litre
    const [lpgPrice, setLpgPrice] = useState(115); // Default per litre
    const [savings, setSavings] = useState(null);

    const calculateSavings = () => {
        if (!distance || !fuelEfficiency || !lpgEfficiency) {
            alert("Please enter all values!");
            return;
        }

        const fuelCost = (distance / fuelEfficiency) * fuelPrice;
        const lpgCost = (distance / lpgEfficiency) * lpgPrice;
        const savingsAmount = fuelCost - lpgCost;

        setSavings({
            fuelCost: fuelCost.toFixed(2),
            lpgCost: lpgCost.toFixed(2),
            savingsAmount: savingsAmount.toFixed(2),
        });
    };

    return (
        <Container>
            <h2 className="text-center">LPG Savings Calculator</h2>
            <Row className="justify-content-center">
                <Col md={6}>
                    <Form>
                        <Form.Group className="mb-3">
                            <Form.Label>Distance (km)</Form.Label>
                            <Form.Control
                                type="number"
                                value={distance}
                                onChange={(e) => setDistance(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>Fuel Efficiency (km/L)</Form.Label>
                            <Form.Control
                                type="number"
                                value={fuelEfficiency}
                                onChange={(e) => setFuelEfficiency(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group className="mb-3">
                            <Form.Label>LPG Efficiency (km/L)</Form.Label>
                            <Form.Control
                                type="number"
                                value={lpgEfficiency}
                                onChange={(e) => setLpgEfficiency(e.target.value)}
                            />
                        </Form.Group>
                        <Button variant="primary" onClick={calculateSavings}>
                            Calculate
                        </Button>
                    </Form>

                    {savings && (
                        <Alert variant="success" className="mt-4">
                            <h4>Results</h4>
                            <p>Fuel Cost: ${savings.fuelCost}</p>
                            <p>LPG Cost: ${savings.lpgCost}</p>
                            <p>Saved: ${savings.savingsAmount}</p>
                        </Alert>
                    )}
                </Col>
            </Row>
        </Container>
    );
};

export default LPGCalculator;
